type ErrorStateProps = Readonly<{
  message: string;
  onRetry?: () => void;
  /** 'page'   — vertically centred card, fills all remaining space (default)
   *  'banner' — slim horizontal bar, anchored to the top of its container */
  variant?: 'page' | 'banner';
}>;

function NetworkIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#DC2626"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

export function ErrorState({ message, onRetry, variant = 'page' }: ErrorStateProps) {
  if (variant === 'banner') {
    return (
      <div
        role="alert"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '10px 16px',
          background: '#FEF2F2',
          border: '1px solid #FECACA',
          borderRadius: 8,
          flexShrink: 0,
          marginBottom: 12,
        }}
      >
        <NetworkIcon />
        <span style={{ flex: 1, fontSize: 13, fontWeight: 500, color: '#991B1B' }}>
          {message}
        </span>
        {onRetry && (
          <button
            className="secondary"
            onClick={onRetry}
            style={{ padding: '4px 14px', fontSize: 13, flexShrink: 0 }}
          >
            Retry
          </button>
        )}
      </div>
    );
  }

  return (
    <div
      role="alert"
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 32,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 14,
          padding: '32px 40px',
          background: 'white',
          borderRadius: 14,
          border: '1px solid #FECACA',
          boxShadow: '0 4px 20px rgba(220, 38, 38, 0.08)',
          maxWidth: 380,
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 52,
            height: 52,
            borderRadius: '50%',
            background: '#FEF2F2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <NetworkIcon />
        </div>

        <div>
          <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text-dark)', marginBottom: 6 }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5 }}>
            {message}
          </div>
        </div>

        {onRetry && (
          <button
            className="secondary"
            onClick={onRetry}
            style={{ marginTop: 2, minWidth: 96, padding: '8px 20px' }}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}
